import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CartContent() {
  return;
}